import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = ({ onWhatsAppClick }) => {
  const contactMethods = [
    {
      icon: 'MessageCircle',
      title: 'WhatsApp',
      description: 'Resposta imediata',
      value: '(62) 99326-3202',
      action: 'Conversar Agora',
      primary: true
    },
    {
      icon: 'Phone',
      title: 'Telefone',
      description: 'Seg à Sex, 9h às 18h',
      value: '(62) 99326-3202',
      action: 'Ligar Agora',
      primary: false
    },
    {
      icon: 'Mail',
      title: 'E-mail',
      description: 'Resposta em até 2h',
      value: 'phmoveisconteporaneos@gmail.com',
      action: 'Enviar E-mail',
      primary: false
    }
  ];

  const showroomInfo = {
    address: 'Rua dos Artesãos, 123 - Vila Madalena',
    city: 'São Paulo - SP',
    cep: '05433-000',
    hours: [
      'Segunda à Sexta: 9h às 18h',
      'Sábado: 9h às 15h',
      'Domingo: Fechado'
    ],
    parking: 'Estacionamento gratuito disponível',
    metro: 'Estação Vila Madalena (Linha 2-Verde)'
  };

  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Methods */}
          <div className="space-y-8">
            <div>
              <h2 className="font-playfair text-3xl font-bold text-primary mb-4">
                Entre em Contato
              </h2>
              <p className="text-xl text-text-secondary">
                Escolha a forma mais conveniente para você. Estamos sempre prontos para ajudar.
              </p>
            </div>

            <div className="space-y-4">
              {contactMethods?.map((method, index) => (
                <div
                  key={index}
                  className={`bg-card rounded-xl p-6 border-2 transition-all duration-300 hover:shadow-premium ${
                    method?.primary ? 'border-primary' : 'border-border hover:border-primary/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                        method?.primary ? 'bg-primary' : 'bg-primary/10'
                      }`}>
                        <Icon 
                          name={method?.icon} 
                          size={24} 
                          color={method?.primary ? 'white' : 'var(--color-primary)'} 
                        />
                      </div>
                      <div>
                        <h3 className="font-semibold text-primary text-lg">
                          {method?.title}
                        </h3>
                        <p className="text-sm text-text-secondary mb-1">
                          {method?.description}
                        </p>
                        <p className="font-medium text-text-primary">
                          {method?.value}
                        </p>
                      </div>
                    </div>
                    
                    <Button
                      variant={method?.primary ? "default" : "outline"}
                      size="sm"
                      iconName="ExternalLink"
                      iconPosition="right"
                      onClick={method?.primary ? onWhatsAppClick : undefined}
                      className={method?.primary ? "bg-primary" : ""}
                    >
                      {method?.action}
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-accent/10 rounded-xl p-6 border border-accent/20">
              <div className="flex items-start space-x-3">
                <Icon name="Clock" size={20} color="var(--color-accent)" className="mt-1" />
                <div>
                  <h4 className="font-semibold text-primary mb-2">
                    Horário de Atendimento
                  </h4>
                  <p className="text-sm text-text-secondary">
                    WhatsApp: 24h (resposta automática fora do horário comercial)\n
                    Telefone e E-mail: Segunda à Sexta, 9h às 18h
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Showroom Info */}
          <div className="space-y-8">
            <div>
              <h2 className="font-playfair text-3xl font-bold text-primary mb-4">
                Visite Nosso Showroom
              </h2>
              <p className="text-xl text-text-secondary">
                Conheça de perto a qualidade dos nossos materiais e acabamentos.
              </p>
            </div>

            <div className="bg-card rounded-xl p-6 shadow-premium">
              <div className="space-y-6">
                <div className="flex items-start space-x-3">
                  <Icon name="MapPin" size={20} color="var(--color-primary)" className="mt-1" />
                  <div>
                    <h4 className="font-semibold text-primary mb-1">Endereço</h4>
                    <p className="text-text-primary">{showroomInfo?.address}</p>
                    <p className="text-text-primary">{showroomInfo?.city}</p>
                    <p className="text-text-secondary text-sm">CEP: {showroomInfo?.cep}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Icon name="Clock" size={20} color="var(--color-primary)" className="mt-1" />
                  <div>
                    <h4 className="font-semibold text-primary mb-2">Horário de Funcionamento</h4>
                    <div className="space-y-1">
                      {showroomInfo?.hours?.map((hour, index) => (
                        <p key={index} className="text-sm text-text-primary">{hour}</p>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Icon name="Car" size={20} color="var(--color-primary)" className="mt-1" />
                  <div>
                    <h4 className="font-semibold text-primary mb-1">Estacionamento</h4>
                    <p className="text-sm text-text-primary">{showroomInfo?.parking}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Icon name="Train" size={20} color="var(--color-primary)" className="mt-1" />
                  <div>
                    <h4 className="font-semibold text-primary mb-1">Transporte Público</h4>
                    <p className="text-sm text-text-primary">{showroomInfo?.metro}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="bg-card rounded-xl overflow-hidden shadow-premium">
              <div className="h-64 w-full">
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  title="PH Móveis Showroom"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps?q=-23.5505,-46.6333&z=15&output=embed"
                  className="border-0"
                ></iframe>
              </div>
              <div className="p-4">
                <Button
                  variant="outline"
                  fullWidth
                  iconName="Navigation"
                  iconPosition="left"
                  className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                >
                  Ver Direções no Google Maps
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;